import { Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'irish',
  templateUrl: './irish.component.html',
  styleUrls: ['./irish.component.scss']
})
export class IrishComponent {

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  constructor() {}

}
